import React from 'react';

import {
    FormField,
    DatePicker,
    ColumnLayout,
    Button
} from 'AWS-UI-Components-React';

import {TaskTable} from "./tables/task_table";

const isDateEnabled = date => date < new Date();

export class Custom extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            date: {
                "end": "",
                "start": ""
            },
            taskLoadDone: false
        };
        // this.clientLoaded = this.clientLoaded.bind(this);
        this.test = this.test.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    test(e) {
        console.log(e);
        this.setState({...this.state, taskLoadDone: true})
    }

    handleDateChange(type, event) {
        this.state.date[type] = event.detail.value;
    }

    render() {
        return (
            <div>
                <div className='col-s-8'>

                    <FormField
                        label="Search Dates"
                    >
                        <ColumnLayout columns={3}>
                            <div data-awsui-column-layout-root="true">
                                <DatePicker
                                    ref={"startDate"}
                                    placeholder="Start Date"
                                    isDateEnabled={isDateEnabled}
                                    onChange={this.handleDateChange.bind(this, 'start')}
                                />
                                <DatePicker
                                    ref={"endDate"}
                                    placeholder="End Date"
                                    isDateEnabled={isDateEnabled}
                                    onChange={this.handleDateChange.bind(this, 'end')}
                                />
                                <Button text="Search" variant="primary" onClick={this.test}></Button>
                            </div>
                        </ColumnLayout>
                    </FormField>
                </div>
                {this.state.taskLoadDone ? <TaskTable type={"custom"} date={this.state.date}/> : null}
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/custom.jsx